import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import { merge, get, clone, set, findIndex } from 'lodash';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Icon, InputItem } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { VBottomNav } from '../../../components/copyright/common';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { getTopicList, getSportList, handleImgData } from './action';
import { getTopicConfigList } from '../home/action';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { base64ToBlob, blobToFile, readCookie } from '../../../utils/common';
import { Vh5Bar } from '../../../components/bar';
import { _track } from '../../../utils/track';
import './index.scss';
const mapStateToProps = state => {
	return {
		sportList: state.CopyrightHomeReducers.sportList,
		topicConfigList: state.CopyrightBaseinfoReducers.topicConfigList
	};
};
let lazyLoadInstance = null;
let initCount = 0;

function CopyrightTopic() {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { sportList = [], topicConfigList = [] } = useMappedState(mapState);
	console.log('sportList...', sportList);
	let [effectFlag, setEffectFlag] = useState(1);
	const [pageData, setPageData] = useState({
		isShowShareTip: false
	});
	let [playerOptions, setPlayerOptions] = useState({});
	let dispatch = useDispatch();
	let location = useLocation();
	useEffect(() => {
		if (effectFlag === 1) {
			setEffectFlag(2);
			if (!get(topicConfigList, ['length'], 0)) {
				dispatch(getTopicConfigList(null));
			}
		}
	}, [dispatch, effectFlag, topicConfigList]);
	let barConfig = {
		barContentText: '全部专题',
		backCallback: () => {
			history.push({
				pathname: '/vpmobile/copyright/home/'
			});
		},
		barRightText: <Icon className="search-icon" type="search" size="sm" />,
		saveCallback: () => {
			history.push({
				pathname: '/vpmobile/copyright/search/5'
			});
		}
	};
	return (
		<div className="copyright copyright-topic">
			<Vh5Bar {...barConfig} />
			<section className="hot-topic-section">
				{get(topicConfigList, ['length'], 0) &&
					topicConfigList.map((item, index) => {
						return (
							<Fragment key={'popic-type-' + index}>
								<div className="topic-title">{item.specialTitle}</div>
								<ul className="topic-list">
									{get(item, ['specialItemResps'], []).map((element, i) => {
										return (
											<li
												key={'popic-type-' + index + '-' + i}
												onClick={() => {
													history.push({
														pathname: '/vpmobile/copyright/search/5',
														state: {
															globalSearchString: get(element, 'specialTag', '')
														}
													});
												}}>
												<div>
													<img alt="" src={get(element, 'specialCover', '')} />
													<span>#{get(element, 'specialTag', '')}</span>
												</div>
											</li>
										);
									})}
									{get(item, ['specialItemResps'], []).slice(0, 9).length % 3 === 2 ? <li></li> : ''}
								</ul>
							</Fragment>
						);
					})}
			</section>
		</div>
	);
}
export { CopyrightTopic };
